import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ReactComponent as Exclamation } from 'assets/icons/exclamation-icon.svg';

const StatementError = () => (
    <div className="statements-not-available" id="statements-not-available">
        <Exclamation />
        <p>
            <FormattedMessage id="statements.statement.api.error" />
        </p>
    </div>
);

export default StatementError;
